import React, { Component } from "react";
import { withRouter } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWallet} from "@fortawesome/free-solid-svg-icons";
import "../Customer/customer.scss";

class CustomerList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            loaded: false,
            preY: 0,
            placeholder: "Loading",
            loading: false,
            option: 1
        };
        this.fetchData = this.fetchData.bind(this);
    }
    fetchData(refesh, option) {
        this.setState({ loading: true });
        let since_id = refesh ? 0 : (this.state.data.length == 0 ? 0 : this.state.data[this.state.data.length - 1].id);
        fetch("/api/CustomerList/" + since_id)
            .then((response) => {
                if (response.status > 400) {
                    return this.setState(() => {
                        return { placeholder: "Something went wrong!" };
                    });
                }
                return response.json();
            })
            .then((data) => {
                console.log(data);
                if (refesh) {
                    this.setState(() => {
                        return {
                            data: data.customers,
                            loaded: true,
                            loading: false,
                            option,
                            preY: 0
                        };
                    });
                } else {
                    this.setState(() => {
                        return {
                            data: [...this.state.data, ...data.customers],
                            loaded: true,
                            loading: false,
                            option
                        };
                    });
                }
            });
    }
    handleObserver(entities, observer) {
        const y = entities[0].boundingClientRect.y;
        if (this.state.prevY > y) {
            this.fetchData(false, this.state.option);
        }
        this.setState({ prevY: y });
    }
    componentDidMount() {
        this.fetchData(true,1);

        var options = {
            root: null,
            rootMargin: "0px",
            threshold: 1.0,
        };

        this.observer = new IntersectionObserver(this.handleObserver.bind(this), options);
        this.observer.observe(this.loadingRef);
    }
    render() {
        const loadingCSS = {
            height: "100px",
            margin: "30px",
        };
        const loadingTextCSS = { display: this.state.loading ? "block" : "none" };
        return (
            <div>
                <div className="custom-main-title">Customers</div>
                <div className="card">
                    <div className="card-body custom-main-body">
                        <ul className="nav custom-nav">
                            <li className={["nav-item", (this.state.option==1?"active":"")].join(" ")}>
                                <a className="nav-link" href="#" onClick={() => this.fetchData(true, 1)}>
                                    All
                                </a>
                            </li>
                            <li className={["nav-item", (this.state.option==2?"active":"")].join(" ")}>
                                <a className="nav-link" href="#" onClick={() => this.fetchData(true, 2)}>
                                    New
                                </a>
                            </li>
                            <li className={["nav-item", (this.state.option==3?"active":"")].join(" ")}>
                                <a className="nav-link" href="#" onClick={() => this.fetchData(true, 3)}>
                                    Returning
                                </a>
                            </li>
                            <li className={["nav-item", (this.state.option==3?"active":"")].join(" ")}>
                                <a className="nav-link" href="#" onClick={() => this.fetchData(true, 3)}>
                                    Abandoned checkouts
                                </a>
                            </li>
                            <li className={["nav-item", (this.state.option==3?"active":"")].join(" ")}>
                                <a className="nav-link" href="#" onClick={() => this.fetchData(true, 3)}>
                                    Email subscribers
                                </a>
                            </li>
                        </ul>
                        <input className="form-control form-control-dark w-100 custom-order-search" type="text" placeholder="Search" aria-label="Search" />
                        <table className="table table-striped table-hover custom-table">
                            <tbody>
                                {this.state.data.map((item, idx) => {
                                    return (
                                        <tr>
                                            <td>
                                                <div className="form-check">
                                                    <input className="form-check-input" type="checkbox" value="" id={"c" + item.id} />
                                                </div>
                                            </td>
                                            <td className="customer-link"
                                                onClick={() => {
                                                    window.open("https://dev-fame-plus.myshopify.com/admin/customers/"+item.id);
                                                }}
                                            >
                                                <div>{item.first_name} {item.last_name}</div>
                                                <div>{item.default_address!=undefined?[item.default_address.city,item.default_address.province,item.default_address.country].join(", "):""}</div>
                                            </td>
                                            <td>{item.email}</td>
                                            <td>
                                                {item.orders_count} orders
                                            </td>
                                            <td>
                                                {item.total_spent} {item.currency} spent
                                            </td>
                                            <td
                                                className="customer-link"
                                                onClick={() => {
                                                    window.open("https://dev-fame-plus.myshopify.com/admin/orders?customer_id="+item.id+"&customers_redirect=true&selectedView=all");
                                                }}
                                            ><FontAwesomeIcon icon={faWallet}/></td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                        <div ref={(loadingRef) => (this.loadingRef = loadingRef)} style={loadingCSS}>
                            <span style={loadingTextCSS}>Loading...</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default withRouter(CustomerList);

